module.exports = __webpack_public_path__ + "img/16 Aniamtion 3-squashed.93ce6d4c.jpg";